import { gql } from 'graphql-request';

const vouchersQuery = gql`
  query vouchers($subdomain: String!, $code: String!) {
    store(subdomain: $subdomain) {
      id
      voucher(code: $code) {
        descriptionAr
        descriptionEn
        discountType
        amount
        minSubtotalAmount
        code
        type
      }
    }
  }
`;

export default vouchersQuery;
